import { motion } from "framer-motion";
import { MANIFESTO } from "../data/content";

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="bg-samatva-ink text-samatva-cream py-28 md:py-40 px-6 md:px-12"
  >
    <div className="max-w-[1200px] mx-auto">
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9 }}
        className="text-xs tracking-[0.35em] uppercase text-samatva-lilac mb-20"
      >
        The Samatva Manifesto
      </motion.p>

      <div className="flex flex-col gap-24 md:gap-32">
        {MANIFESTO.map((ch, i) => (
          <motion.div
            key={ch.number}
            data-testid={`manifesto-chapter-${i + 1}`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className={`grid grid-cols-1 md:grid-cols-12 gap-6 items-start ${
              i % 2 === 1 ? "md:text-right" : ""
            }`}
          >
            <span
              className={`md:col-span-4 font-serif text-8xl md:text-[10rem] font-light leading-none text-transparent opacity-40 ${
                i % 2 === 1 ? "md:order-2" : ""
              }`}
              style={{ WebkitTextStroke: "1px #C9AFE4" }}
            >
              {ch.number}
            </span>
            <div className="md:col-span-8">
              <h3 className="font-serif text-3xl md:text-5xl font-light tracking-tight leading-tight">
                {ch.title}
              </h3>
              <p className="mt-6 text-base md:text-lg font-light leading-relaxed text-samatva-lavender/80 max-w-xl inline-block">
                {ch.body}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
